import React from 'react';
import { PromoBanner } from '@moda/om';
import gql from 'graphql-tag';
import { Link } from '../Link';
import {
  SitePromoBannerFragment,
  SitePromoBannerFragment_targetBuckets_modules_SinglePumoModule as SinglePumoModuleType,
  SitePromoBannerFragment_targetBuckets_modules_SinglePumoModule_slides as SinglePumoModuleSlide
} from '../../generated/types/SitePromoBannerFragment';
import { stripHTMLTags } from '../NormalizePumoStyles';
import { SitePromoBannerCountrySelector } from './SitePromoBannerCountrySelector';
import { SitePromoBannerLink } from './SitePromoBannerLink';

import './SitePromoBanner.scss';

export const SITE_PROMO_BANNER_FRAGMENT = gql`
  fragment SitePromoBannerFragment on DisplayPage {
    targetBuckets {
      name
      modules {
        ... on SinglePumoModule {
          slides {
            ctaUrl
            slideText {
              taglineText {
                body
              }
            }
          }
        }
      }
    }
  }
`;

const SITE_PROMO_BANNER_FALLBACK_MESSAGE =
  'Free Shipping & Returns in the U.S. | Use Code NEWTOMODA for 10% Off Your First Full-Price Purchase';

interface Props {
  displayPage?: SitePromoBannerFragment | null;
}

export const SitePromoBanner: React.FC<Props> = ({ displayPage }) => {
  const bannerSlide: SinglePumoModuleSlide | null = (displayPage?.targetBuckets.find(
    ({ name }) => name === 'banner'
  )?.modules[0] as SinglePumoModuleType)?.slides[0];

  const promoBannerMessageHTML = bannerSlide?.slideText?.taglineText?.body;

  const promoBannerMessage = stripHTMLTags(
    promoBannerMessageHTML || SITE_PROMO_BANNER_FALLBACK_MESSAGE
  );

  return (
    <PromoBanner role="banner" className="SitePromoBanner">
      <div className="SitePromoBanner__cell">
        <SitePromoBannerCountrySelector />
      </div>

      <Link
        className="SitePromoBanner__cell SitePromoBanner__cta"
        to={bannerSlide?.ctaUrl || '#'}
        title={promoBannerMessage}
        dangerouslySetInnerHTML={{ __html: promoBannerMessage }}
      />

      <div className="SitePromoBanner__cell">
        <SitePromoBannerLink />
      </div>
    </PromoBanner>
  );
};
